import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import "./styles.scss";
import parse from "html-react-parser";
import Para from "../Para";
import { secondsToHms } from "../../services/CommonService";

export default function AccordionComponent(props) {
  const {
    courseModule,
    selectedCourse,
    setCustomModuleList,
    setTotalPrice,
    setSelectedCount,
  } = props;

  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    console.log("Checked items ", checkedItems);
  }, [checkedItems]);

  useEffect(() => {
    setCheckedItems(Array(courseModule.length).fill(false));
  }, [courseModule.length]);

  const handleCustomCheck = (event, index) => {
    const newCheckedItems = [...checkedItems];
    newCheckedItems[index] = event.target.checked;
    setCheckedItems(newCheckedItems);
  };

  const getCheckedItemsData = () => {
    return courseModule.filter((item, index) => checkedItems[index]);
  };

  useEffect(() => {
    const checkedItemsData = getCheckedItemsData();
    const moduleIds = checkedItemsData.map((item) => item.id);
    setCustomModuleList(moduleIds);

    const checkeItemPrice = checkedItemsData.reduce((accumulator, item) => {
      return accumulator + item.price;
    }, 0);
    setTotalPrice(checkeItemPrice);

    const selectedItemsCount = checkedItemsData.length;
    setSelectedCount(selectedItemsCount);

    console.log(
      "Checked Items Data:",
      checkedItemsData,
      "Module IDs:",
      moduleIds,
    );
  }, [checkedItems, courseModule, setCustomModuleList]);

  const [itmesLength, setItemsLength] = useState(courseModule.length);

  return (
    <>
      <div className="accordion-wrapper">
        <Accordion defaultActiveKey={itmesLength === 1 ? "0" : undefined}>
          {" "}
          {/* defaultActiveKey="0" */}
          {courseModule.map((item, index) => (
            <Accordion.Item eventKey={String(index)} key={item.id}>
              <Accordion.Header className="header-accordion acc-btn">
                <span>{item.name}</span>
                <span className="text-right text-primary">
                  {selectedCourse === "Custom Course" && (
                    <>
                      ₹ {item?.price}
                      <input
                        type="checkbox"
                        className="ms-3 mr-3"
                        name={`chapter-${index}`}
                        checked={checkedItems[index]}
                        onChange={(event) => handleCustomCheck(event, index)}
                      />
                    </>
                  )}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <Para className="para f14 px-4 pt-4 summary_table">
                  {parse(item.summary)}
                </Para>
                {/* <strong className="para f14 px-4 pt-4">modules</strong> */}
                {/*                 <ul className="px-4">
                  {item.contentList.map((content, index) => (
                    <li key={index} className="d-flex justify-content-between">
                      <p>{content.name}</p>
                      <p>{secondsToHms(content.duration)}</p>
                    </li>
                  ))}
                </ul> */}
                {/* {item.content.map((content)=> (
                  <Para className="para f14">{parse(content.name)}</Para>
                ))
                } */}
                {/* <Para className="para f14">{parse(item.description)}</Para> */}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </>
  );
}
